module.exports = __webpack_public_path__ + "static/media/sneakpeak-00.f3921da1.jpg";